/** Alarm types returned from API (`alarm_log` joined with `alarm_types`). */
export type NormalizedAlarmKind = 'high' | 'low' | 'battery' | 'missing_data' | 'other';

export function normalizeAlarmType(t: string | undefined): NormalizedAlarmKind {
  const s = String(t ?? '').toLowerCase();
  if (s === 'high') return 'high';
  if (s === 'low') return 'low';
  if (s === 'battery') return 'battery';
  if (s === 'missing_data') return 'missing_data';
  return 'other';
}

export function alarmTypeShortLabel(t: string | undefined): string {
  switch (normalizeAlarmType(t)) {
    case 'high':
      return 'High';
    case 'low':
      return 'Low';
    case 'battery':
      return 'Battery low';
    case 'missing_data':
      return 'Stale data';
    default:
      return String(t ?? 'Alarm');
  }
}

/** Value line after "—" on banners / lists (temperature °C, battery V, or raw text for stale). */
export function formatAlarmReading(t: string | undefined, values: unknown): string {
  const k = normalizeAlarmType(t);
  if (values === null || values === undefined || values === '' || values === '-') return '—';
  if (k === 'battery') return `${values} V`;
  if (k === 'missing_data') return String(values);
  if (k === 'high' || k === 'low') return `${values}°C`;
  return String(values);
}
